export default class ReadMore {
	constructor(el) {
		this.element = el

		this.addEventListeners(el)
	}

	parentsUntilTree = (element, stopSelector) => {
		let currentElement = element
		let tree = null

		while (
			currentElement &&
			(!stopSelector || !currentElement.matches(stopSelector))
		) {
			tree = { element: currentElement, child: tree }
			currentElement = currentElement.parentElement
		}

		return tree
	}

	addEventListeners(el) {
		el.addEventListener("click", (event) => {
			event.stopPropagation()
			let content = null
			const tree = this.parentsUntilTree(event.target, ".widget")
			if (!tree || !tree.child || !tree.child.element) return

			const element = tree.child.element

			let selector = null
			switch (true) {
				case element.querySelector(':scope > [class*="__content"]') !==
					null:
					selector = ':scope > [class*="__content"]'
					break
				case element.querySelector(':scope > [class*="--content"]') !==
					null:
					selector = ':scope > [class*="--content"]'
					break
				case element.querySelector(".c-details-hero__footnote") !==
					null:
					selector = ".c-details-hero__footnote"
					break
				case element.querySelector(".c-cta__text") !== null:
					selector = ".c-cta__text"
					break
			}

			// Assign content if a selector was found
			if (selector) {
				content = element.querySelector(selector)
			}

			if (content) {
				content.classList.toggle("revealed")
				event.target.classList.toggle("active")
			}

			if (el.parentElement.classList.contains("c-content-slider__text")) {
				el.parentElement.classList.toggle("revealed")
			}

			if (event.target.classList.contains("active")) {
				let origMesg = event.target.innerHTML
				let readMsg = origMesg.replace(origMesg, "Hide details")
				event.target.innerHTML = readMsg
			} else {
				let origMesg = event.target.innerHTML
				let readMsg = origMesg.replace(origMesg, "View details")
				event.target.innerHTML = readMsg
			}
		})
	}
}
